<div class="popup-overlay" [class.show]="showPopup" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-logo"><img src="assets/images/synergyLogo.png"></div>
    <div class="popup-wrapper">
      <div class="popup-text">
        <span>{{'splash_dialog_1' | translate}}</span><br/>
      </div>
       <div class="popup-text">
        <span>{{'splash_dialog_2' | translate}}</span><br/>
      </div>
       <div class="popup-text">
        <span>{{'splash_dialog_3' | translate}}</span><br/>
      </div>
    </div>
    
    <div class="popup-close" (click)="close(true)">
      <span>{{'splash_download_button' | translate}}</span>
    </div>
  </div>
</div>
